import React, { useState, useEffect, useContext } from 'react';
import { getPageOfTenBlogs, getBearerToken, jsonParseUTF, dynamicResourceLinks, useGetPath, globalUnifiedOptions } from "./util";
import LoadingBlog from "./LoadingBlogs";
import ReactMarkdown from "react-markdown";
import ControlPannel from "./ControlPannel";
import CustomLink from './CustomLink'
import { string as toStyleString } from 'to-style'
import $ from 'jquery'
import ReactDOM from 'react-dom';
import axios from 'axios';
import { globalContext } from './App';

var jsblog

var integer = 0
var settimeoutid = -1

function loadingMessage(elid) {
	var rem = 7
	ReactDOM.render(
		<div className="message" style={{
		}}>
			{"Deleting\u00A0" + String("\u00A0".repeat(5) + "..." + "\u00A0".repeat(5)).substring(rem - integer, 5 + rem - integer)}
		</div>, document.getElementById(elid)
	)
	integer += 1
	integer %= rem
	settimeoutid = setTimeout(() => { loadingMessage(elid) }, 75)
}

function getBlog(globalBlogs, path) {
	// console.log({globalBlogs})
	var allblogs = JSON.parse(globalBlogs)
	var filtered = allblogs.filter(block => block.attributes.slug === path)
	// console.log(filtered)
	if (filtered && filtered.length === 1 && filtered[0]) {
		return filtered
	}
	return null
}

function getRenderedBlog(globalBlogs, path, setslug) {
	var content;
	var allblogs = JSON.parse(globalBlogs)
	content = allblogs.filter(block => block.attributes.slug === path).map(block => {
		var blog = block.attributes
		setslug(blog.slug)
		// console.log(blog.content)
		blog.content = jsonParseUTF(blog.content)
		return (
			<div className={blog.slug + " blog"} key={block.id}>
				<h1 className="title">{jsonParseUTF(blog.title)}</h1>
				<ReactMarkdown className="content" {...globalUnifiedOptions}>
					{blog.content}
				</ReactMarkdown>
			</div>
		);
	})
	return content
}

const Blog = () => {
	const { globalBlogs, setGlobalBlogs, setGlobalBlog } = useContext(globalContext)
	var path = useGetPath().substring("/blogs/".length)
	var tmpslug = ""
	const [blog] = useState((() => {
		if (globalBlogs) {
			var tmp = getBlog(globalBlogs, path)
			console.log({blog: tmp})
			if (!tmp)
				return undefined
			jsblog = tmp[0]
			return tmp
		}
		return null
	})())
	const [renderedblog, setRenderedBlog] = useState((() => {
		if (globalBlogs) {
			return getRenderedBlog(globalBlogs, path, (str) => { tmpslug = str })
		}
		return <></>
	})()
	);
	const [slug, setslug] = useState(tmpslug);
	// console.log({ blog })
	useEffect(() => {
		if (globalBlogs === null) {
			setRenderedBlog(
				<>
					<LoadingBlog></LoadingBlog>
					<LoadingBlog></LoadingBlog>
					<LoadingBlog></LoadingBlog>
				</>
			)
			getPageOfTenBlogs().then(response => {
				setGlobalBlogs(JSON.stringify(response.data.data))
			}).catch(res => {
				setRenderedBlog(<>
					<div className="error">{res.toString()}</div>
				</>)
			})
		}
		else {
			var content = getRenderedBlog(globalBlogs, path, setslug)
			// console.log("setting the visible blogs")
			if ((!content) || (content && content.length === 0)) {
				console.log({ content })
				setRenderedBlog(<>
					<div className="error" style={{textAlign: "center"}}>
						The blog you're looking for does not exist...
					</div>
				</>)
			}
			else
				setRenderedBlog(content)
		}
		// console.log({blog}, "ue")
	}, [globalBlogs, path, setGlobalBlogs])
	return (
		<>
			<div id="confirm-delete" className='flex-jc-cr flex-column flex-ai-cr' style={{ display: "none" }}>
				<p className="text">
					Are you sure you want to delete this blog? <br></br>
					This action is irreversable.
				</p>
				<div className="button-container flex-jc-cr flex-ai-cr">
					<button className="util-button confirm"
						onClick={() => {
							$("#confirm-delete").attr("style", toStyleString({ display: "none" }))
							// var st_id = -1
							loadingMessage("delete-message")
							// console.log({jsblog}, "clicked and confirmed delete")
							// return
							axios.delete("https://api.pcbang.ma/api/articles/" + jsblog.id.toString(),
								{
									headers: {
										Authorization: getBearerToken()
									}
								}
							).then((res) => {
								console.log(res)
								clearTimeout(settimeoutid)
								ReactDOM.render(<div className='message' style={{color: "lime", width: "unset"}}>Done!</div>, document.getElementById("delete-message"))
							}).catch((err) => {
								console.log(err)
								clearTimeout(settimeoutid)
								ReactDOM.render(<div className='message' style={{color: "red", width: "unset"}}>{err.toString()}</div>, document.getElementById("delete-message"))
							})
						}}
					>Confirm</button>
					<button className="util-button cancel"
						onClick={() => {
							$("#confirm-delete").attr("style", toStyleString({ display: "none" }))
						}}
					>Cancel</button>
				</div>
			</div>
			<div className="pagebody blogs">
				<div className="mainbody">
					<div className="navpad"></div>
					<ControlPannel >
						<div className="delete flex-jc-cr flex-ai-cr flex-gap10">
							<div className="users left react-router-link"
								// {...mouseEventStyles(
								// 	{ backgroundColor: "rgba(255, 255, 255, 0.2)" },
								// 	{ backgroundColor: "rgba(255, 255, 255, 0.3)" }
								// )}
								onClick={() => {
									if (jsblog)
										$("#confirm-delete").attr("style", toStyleString({ position: "fixed" }))
								}}
							>
								<img src={dynamicResourceLinks("ff09ff").trashCanIcon} alt="" className="icon" />
								<div className="tooltip">
									delete this blog
								</div>
							</div>
							<div id="delete-message"></div>
						</div>
						<CustomLink className="newblog react-router-link right"
							// {...mouseEventStyles(
							// 	{ backgroundColor: "rgba(255, 255, 255, 0.2)" },
							// 	{ backgroundColor: "rgba(255, 255, 255, 0.3)" }
							// )}
							to={"/edit/" + slug}
							onClick={() => {
								setGlobalBlog(blog)
							}}
						>
							<img src={dynamicResourceLinks("ff09ff").editPenIcon} alt="" className="icon" />
							<div to={"/edit/" + slug} className="tooltip">
								Edit This Blog
							</div>
						</CustomLink>
					</ControlPannel>
					<div className="blogscontainer">
						{renderedblog}
					</div>
				</div>
			</div>
		</>
	);
}

export default Blog;